import type { Provider } from '@angular/core';

import { provideTellentAssistantRenderPresenter } from '@core/tellent-assistant-contracts';
import type { PresentMetricSummaryArgs } from '@core/tellent-assistant-types';

import { AssistantPresentMetricSummaryComponent } from './present-metric-summary.component';

export const providePresentMetricSummaryClientTool: Provider =
  provideTellentAssistantRenderPresenter<PresentMetricSummaryArgs>({
    id: 'presentMetricSummary',
    component: AssistantPresentMetricSummaryComponent,
  });
